export const ChartGroups = [
  { propertyName: 'voltage', name: 'Voltage' },
  { propertyName: 'powers', name: 'Powers' },
  { propertyName: 'currents', name: 'Currents' },
  { propertyName: 'voltageHarmonics', name: 'Voltage Harmonics' },
  { propertyName: 'currentHarmonics', name: 'Current Harmonics' },
  { propertyName: 'voltageIHarmonics', name: 'Voltage Interharmonics' },
  { propertyName: 'currentIHarmonics', name: 'Current Interharmonics' },
];
